import { render, staticRenderFns } from "./ShowLogDetailsModal.vue?vue&type=template&id=1f486f89&scoped=true&"
import script from "./ShowLogDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ShowLogDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f486f89",
  null
  
)

export default component.exports